import { ChartTooltipState } from '@/components/chart/chart-tooltip/chart-tooltip.types';

export const state: ChartTooltipState = {
  params: [],
  isTooltipVisible: false,
};
